var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCircleUpXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46826 7.99998C1.46826 4.04194 4.67689 0.833313 8.63493 0.833313C12.593 0.833313 15.8016 4.04194 15.8016 7.99998C15.8016 11.958 12.593 15.1666 8.63493 15.1666C4.67689 15.1666 1.46826 11.958 1.46826 7.99998ZM8.63493 1.83331C5.22917 1.83331 2.46826 4.59422 2.46826 7.99998C2.46826 11.4057 5.22917 14.1666 8.63493 14.1666C12.0407 14.1666 14.8016 11.4057 14.8016 7.99998C14.8016 4.59422 12.0407 1.83331 8.63493 1.83331Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63493 4.66665C8.91107 4.66665 9.13493 4.8905 9.13493 5.16665V11.1666C9.13493 11.4428 8.91107 11.6666 8.63493 11.6666C8.35879 11.6666 8.13493 11.4428 8.13493 11.1666V5.16665C8.13493 4.8905 8.35879 4.66665 8.63493 4.66665Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28137 4.81309C8.47664 4.61783 8.79322 4.61783 8.98848 4.81309L11.9885 7.81309C12.1837 8.00835 12.1837 8.32494 11.9885 8.5202C11.7932 8.71546 11.4766 8.71546 11.2814 8.5202L8.63493 5.87375L5.98848 8.5202C5.79322 8.71546 5.47664 8.71546 5.28137 8.5202C5.08611 8.32494 5.08611 8.00835 5.28137 7.81309L8.28137 4.81309Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleUpXs);
export default __webpack_public_path__ + "static/media/arrow-circle-up-xs.bb2c76e6.svg";
export { ForwardRef as ReactComponent };